(function () {
  'use strict';

  function initStickyAddToCart(container) {
    if (!container || container.dataset.initialized === 'true') {
      return;
    }

    container.dataset.initialized = 'true';

    const sectionId = container.dataset.sectionId;
    const submitButtonId = container.dataset.submitButton;

    const originalSubmit = document.getElementById(submitButtonId);

    if (!originalSubmit) {
      return;
    }

    const stickyButton = container.querySelector('[data-sticky-submit]');
    const stickyButtonText = container.querySelector('[data-sticky-button-text]');
    const stickyPrice = container.querySelector('[data-sticky-price]');
    const stickyImage = container.querySelector('.sticky-atc__image img');

    const variantDataElement = container.querySelector('[data-sticky-variants]');

    let variants = [];

    if (variantDataElement) {
      try {
        variants = JSON.parse(variantDataElement.textContent);
      } catch (error) {
        console.warn('Sticky ATC: Could not read variant data.', error);
      }
    }

    const selects = Array.from(
      container.querySelectorAll('.sticky-atc__select')
    );

    /*
     * Show/hide sticky bar based on original Add To Cart button.
     */
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {

          if (entry.isIntersecting) {
            container.classList.remove('is-visible');
          } else {
            container.classList.add('is-visible');
          }

        });
      },
      {
        root: null,
        threshold: 0.05
      }
    );

    observer.observe(originalSubmit);


    /*
     * Format money using Shopify's current money format.
     */
    function formatMoney(cents) {

      const amount = Number(cents || 0) / 100;

      return new Intl.NumberFormat(
        document.documentElement.lang || 'en-AU',
        {
          style: 'currency',
          currency: 'AUD'
        }
      ).format(amount);

    }


    /*
     * Find selected variant.
     */
    function getSelectedVariant() {

      if (!variants.length) {
        return null;
      }

      if (!selects.length) {
        return variants[0];
      }

      const selectedOptions = selects.map(function (select) {
        return select.value;
      });

      return variants.find(function (variant) {

        return variant.options.every(function (option, index) {
          return option === selectedOptions[index];
        });

      }) || null;
    }


    /*
     * Update main Dawn product form.
     */
    function updateMainProductForm(variant) {

      if (!variant) {
        return;
      }

      const productInfo = container.closest('product-info');

      if (!productInfo) {
        return;
      }

      const productForm =
        productInfo.querySelector('form[data-type="add-to-cart-form"]');

      if (!productForm) {
        return;
      }

      const variantInput =
        productForm.querySelector('input[name="id"]');

      if (!variantInput) {
        return;
      }

      variantInput.value = variant.id;

      variantInput.disabled = !variant.available;

      variantInput.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );

    }


    /*
     * Update sticky UI.
     */
    function updateSticky(variant) {

      if (!variant) {

        if (stickyButton) {
          stickyButton.disabled = true;
        }

        if (stickyButtonText) {
          stickyButtonText.textContent = 'Unavailable';
        }

        return;
      }


      /*
       * Price
       */
      if (stickyPrice) {
        stickyPrice.textContent = formatMoney(variant.price);
      }


      /*
       * Image
       */
      if (
        stickyImage &&
        variant.featured_image &&
        variant.featured_image.src
      ) {

        stickyImage.src = variant.featured_image.src;

      }


      /*
       * Availability
       */
      if (stickyButton) {

        stickyButton.disabled = !variant.available;

      }


      if (stickyButtonText) {

        if (variant.available) {

          stickyButtonText.textContent = 'Add to cart';

        } else {

          stickyButtonText.textContent = 'Sold out';

        }

      }


      /*
       * Sync with Dawn main product form.
       */
      updateMainProductForm(variant);

    }


    /*
     * Variant selector change.
     */
    selects.forEach(function (select) {

      select.addEventListener('change', function () {

        const variant = getSelectedVariant();

        updateSticky(variant);

      });

    });


    /*
     * Initial state.
     */
    const initialVariant = getSelectedVariant();

    if (initialVariant) {
      updateSticky(initialVariant);
    }


    /*
     * Keep sticky button state synced
     * with Dawn's main Add To Cart button.
     */
    const buttonObserver = new MutationObserver(function () {

      if (!stickyButton) {
        return;
      }

      const disabled =
        originalSubmit.disabled;

      stickyButton.disabled = disabled;

      if (stickyButtonText && disabled) {

        const originalText =
          originalSubmit.querySelector('span');

        if (originalText) {
          stickyButtonText.textContent =
            originalText.textContent.trim();
        }

      }

    });

    buttonObserver.observe(
      originalSubmit,
      {
        attributes: true,
        childList: true,
        subtree: true
      }
    );

  }


  /*
   * Initialize existing sticky ATC.
   */
  function initializeAll() {

    document
      .querySelectorAll('.sticky-atc')
      .forEach(function (container) {

        initStickyAddToCart(container);

      });

  }


  /*
   * Initial page load.
   */
  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initializeAll
    );

  } else {

    initializeAll();

  }


  /*
   * Dawn may replace product sections
   * during variant changes.
   */
  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const container =
        event.target.querySelector('.sticky-atc');

      if (container) {
        initStickyAddToCart(container);
      }

    }
  );


})();